import "core-js/modules/es.number.to-fixed";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import CodeTable from '../App/CodetableService';
/**
 * Represents a specific payment, for a given period for a specific entitlement.
 * @class
 * @memberof PaymentsModels
 */

var PaymentDetail =
/**
 * Creates an instance of PaymentDetail.
 *
 * @param {any} json The json input containing a list of messages in a json format.
 * @memberof PaymentDetail
 */
function PaymentDetail(json) {
  _classCallCheck(this, PaymentDetail);

  this.benefitName = json.benefitName;
  this.caseReference = json.caseReference;
  this.coverStartDate = new Date(json.coverStartDate);
  this.coverEndDate = new Date(json.coverEndDate);
  this.debitAmount = json.debitAmount.toFixed(2);
  this.creditAmount = json.creditAmount.toFixed(2);
  this.caseId = json.caseId;
  this.entitlement = CodeTable.fromJSON(json.entitlement);
};
/**
 * Represents a Payment made up for 1 or more {@link PaymentsModels.PaymentDetail} records.
 *
 * A payment is a grouping of one or more specific payments that are rolled up and
 * delivered as a single payment.
 *
 * @class
 * @memberof PaymentsModels
 */


var Payment =
/**
 * Creates an instance of Payment.
 *
 * @param {any} json The json input containing a list of messages in a json format.
 * @memberof Payment
 */
function Payment(json) {
  var _context;

  _classCallCheck(this, Payment);

  this.paymentId = json.payment_id;
  this.paymentDate = new Date(json.paymentDate);
  this.coverStartDate = new Date(json.coverStartDate);
  this.coverEndDate = new Date(json.coverEndDate);
  this.dueDate = new Date(json.dueDate);
  this.payedByName = json.payedByName;
  this.amount = json.amount.toFixed(2);
  this.nominatedPayeeName = json.nominatedPayeeName;
  this.nominatedPayeeAddress = json.nominatedPayeeAddress;
  this.checkNumber = json.checkNumber;
  this.voucherNumber = json.voucherNumber;
  this.bankSortCode = json.bankSortCode;
  this.bankAccountNumber = json.bankAccountNumber;
  this.external = json.external;
  this.currency = CodeTable.fromJSON(json.currency);
  this.method = CodeTable.fromJSON(json.method);
  this.status = CodeTable.fromJSON(json.status);
  this.statusOther = CodeTable.fromJSON(json.statusOther);
  this.details = _mapInstanceProperty(_context = json.paymentDetails).call(_context, function (detailsJson) {
    return new PaymentDetail(detailsJson);
  });
};
/**
 * The Payment and PaymentDetails data models.
 *
 * @export
 * @class PaymentsModels
 */


export default {
  /**
   * Represents a specific payment, for a given period for a specific entitlement.
   * @class
   * @memberof PaymentsModels
   */
  PaymentDetail: PaymentDetail,

  /**
   * Represents a Payment made up for one or more {@link PaymentsModels.PaymentDetail} records.
   *
   * A payment is a grouping of one or more specific payments that are rolled up and
   * delivered as a single payment.
   *
   * @class
   * @memberof PaymentsModels
   */
  Payment: Payment
};